import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { resetPassword } from "api";
import { Spinner } from "components/common";

export default function ResetPasswordPage() {
  const { token }                       = useParams<{ token: string }>();
  const navigate                        = useNavigate();
  const [password, setPassword]         = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [success, setSuccess]           = useState(false);

  const { mutate, isPending, error } = useMutation({
    mutationFn: () => resetPassword(token!, password, confirmation),
    onSuccess:  () => setSuccess(true),
  });

  const mismatch = confirmation.length > 0 && password !== confirmation;

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="card w-full max-w-sm p-8 text-center space-y-4">
          <h1 className="text-base font-semibold text-gray-900">Password updated</h1>
          <p className="text-sm text-gray-500">You can now sign in with your new password.</p>
          <button className="btn-primary w-full" onClick={() => navigate("/login")}>Go to sign in</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card w-full max-w-sm p-8">
        <div className="text-center mb-8">
          <h1 className="text-xl font-semibold text-brand-600">Bridge 13</h1>
          <p className="text-sm text-gray-500 mt-1">Set a new password</p>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); mutate(); }} className="space-y-4">
          <div>
            <label className="label">New password</label>
            <input type="password" className="input" value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters"
              minLength={8} required autoFocus />
          </div>
          <div>
            <label className="label">Confirm password</label>
            <input type="password" className={"input " + (mismatch ? "border-red-300" : "")}
              value={confirmation} onChange={(e) => setConfirmation(e.target.value)}
              placeholder="Repeat your password" required />
            {mismatch && <p className="text-xs text-red-500 mt-1">Passwords do not match.</p>}
          </div>
          {error && <p className="text-sm text-red-500">This reset link is invalid or has expired.</p>}
          <button type="submit" className="btn-primary w-full"
            disabled={isPending || mismatch || !password || !confirmation}>
            {isPending ? <Spinner className="h-4" /> : "Update password"}
          </button>
        </form>
      </div>
    </div>
  );
}
